import React from "react";
import { Stack, TextField, MenuItem } from "@mui/material";

export default function EquipmentFilters({
  filters,
  onFilterChange,
  searchText,
  onSearchTextChange,
  departments,
}) {
  return (
    <Stack spacing={2}>
      <TextField
        placeholder="Search equipment..."
        fullWidth
        size="small"
        value={searchText}
        onChange={(e) => onSearchTextChange(e.target.value)}
      />

      <TextField
        select
        label="Department"
        value={filters.department}
        onChange={(e) => onFilterChange("department")(e.target.value)}
        size="small"
        fullWidth
      >
        {departments.map((dep) => (
          <MenuItem key={dep} value={dep}>
            {dep}
          </MenuItem>
        ))}
      </TextField>

      <TextField
        select
        label="Type"
        value={filters.type}
        onChange={(e) => onFilterChange("type")(e.target.value)}
        size="small"
        fullWidth
      >
        {[
          "All",
          "Printer",
          "Measurement",
          "Machine",
          "Sensor",
          "Scanner",
          "Engraver",
        ].map((type) => (
          <MenuItem key={type} value={type}>
            {type}
          </MenuItem>
        ))}
      </TextField>
    </Stack>
  );
}
